import Image from 'next/image'
import { Fragment } from 'react'

import { Icon } from '@/shared/ui/icon'
import { Popover } from '@/shared/ui/Popover'

import importantIcon from '../assets/icons/important.svg'
import plusIcon from '../assets/icons/plus.svg'
import { PROMO_IPHONE_18_IMAGES_URL } from '../assets/images'

import cl from './GiftsSection.module.scss'

const giftCards = [
	{
		title: 'Сетевое зарядное устройство',
		image: `${PROMO_IPHONE_18_IMAGES_URL}/card-1-1440.webp`,
		tooltip: 'Количество подарков ограничено.'
	},
	{
		title: 'Установка любимого приложения',
		image: `${PROMO_IPHONE_18_IMAGES_URL}/card-2-1440.webp`,
		tooltip: 'Услуга может быть недоступна в отдельных случаях по техническим причинам.'
	}
] as const

export const GiftsSection = () => {
	return (
		<section className={cl.root}>
			{/*<h2 className={cl.title}>Ваши подарки за&nbsp;предзаказ в&nbsp;iPort:</h2>*/}

			<div className={cl.cards}>
				{giftCards.map(({ title, image, tooltip }, index) => (
					<Fragment key={index}>
						<article className={cl.card}>
							<div className={cl.cardHeader}>
								<h3 className={cl.cardTitle}>{title}</h3>
								{tooltip && (
									<Popover
										as="span"
										content={tooltip}
										placement="bottomRight"
										overlayInnerStyle={{ maxWidth: '25rem', padding: '16px' }}>
										<button className={cl.tooltipButton} type="button" aria-label="Подробнее">
											<Icon className={cl.tooltipIcon} icon={importantIcon} width={4} height={19} />
										</button>
									</Popover>
								)}
							</div>

							<Image
								className={cl.cardImage}
								src={image}
								alt=""
								fill
								sizes="(min-width: 992px) 562px, (min-width: 768px) 620px, 300px"
							/>
						</article>

						{index === 0 && (
							<div className={cl.plus} aria-hidden="true">
								<Icon className={cl.plusIcon} icon={plusIcon} width={13} height={13} />
							</div>
						)}
					</Fragment>
				))}
			</div>
		</section>
	)
}
